import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { formatNumber } from "@otp/utils";
import { Typography } from "../typography";
import styles from "./table.module.css";
export const PaginationCounter = (props) => {
    const { count = 0, page, rowsPerPage } = props;
    const { t } = useTranslation();
    const getPaginationCounts = () => {
        const from = count > 0 ? page * rowsPerPage + 1 : 0;
        const to = (page + 1) * rowsPerPage;
        const defaultTitle = `Results ${formatNumber(from || 0)}-${formatNumber((to <= count ? to : count) || 0)} of ${formatNumber(count)} in total`;
        return t("table.title", defaultTitle, {
            from: formatNumber(from),
            to: formatNumber(to <= count ? to : count),
            total: formatNumber(count),
        });
    };
    return (_jsx(Typography, { variant: "subtitle1", fontWeight: "bold", className: styles.title, "data-testid": "table-title", children: getPaginationCounts() }));
};
export default PaginationCounter;
